import React from 'react';
import { useAccount } from 'wagmi';

export const withWallet = (Component: typeof React.Component) => {
  // eslint-disable-next-line react/display-name
  return (props: any) => {
    const { address: account } = useAccount();

    return <Component {...props} wallet={account} />;
  };
};
